<template>
  <div id="contestfooterblock" class="middle-aligned">
    <el-row :gutter="5">
      <el-col :span="2">
        <div class="grid-content">
          <span v-if="showExit">
            <el-button icon="el-icon-close" class="footer-button exit-button" @click="tryExit">Завершить</el-button>
          </span>
        </div>
      </el-col>
      <el-col :span="18">
        <div class="grid-content">
          <span v-if="showProgress">
            <el-row :gutter="2">
              <el-col :span="3">
                <div class="grid-content-small footer-text right-floated">
                  Тест:
                </div>
              </el-col>
              <el-col :span="2">
                <div class="grid-content-small footer-text centered">
                  {{ scenarioTestsPassedCount }} / {{ scenarioTestsCount }}
                </div>
              </el-col>
              <el-col :span="7">
                <div class="grid-content-small">
                  <el-progress :text-inside="true" :stroke-width="18" :percentage="testPercentage" :show-text="false"></el-progress>
                </div>
              </el-col>
              <el-col :span="3">
                <div class="grid-content-small footer-text right-floated">
                  Вопрос:
                </div>
              </el-col>
              <el-col :span="2">
                <div class="grid-content-small footer-text centered">
                  {{ testQuestionsPassedCount }} / {{ testQuestionsCount }}
                </div>
              </el-col>
              <el-col :span="7">
                <div class="grid-content-small">
                  <el-progress :text-inside="true" :stroke-width="18" :percentage="questionPercentage" :show-text="false"></el-progress>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="2">
              <el-col :span="3">
                <div class="grid-content-small footer-text right-floated">
                  Осталось времени:
                </div>
              </el-col>
              <el-col :span="2">
                <div class="grid-content-small footer-text centered">
                  {{estimatedTime}}
                </div>
              </el-col>
              <el-col :span="19">
                <div class="grid-content-small">
                  <el-progress :text-inside="true" :stroke-width="18" :percentage="timePercenatge" :show-text="false"></el-progress>
                </div>
              </el-col>
            </el-row>
          </span>
        </div>
      </el-col>
      <el-col :span="2">
        <div class="grid-content">
          <span v-if="showSkip">
            <el-button class="skip-button footer-button right-floated" @click="skip(false)">Пропустить</el-button>
          </span>
        </div>
      </el-col>
      <el-col :span="2">
        <div class="grid-content">
          <span v-if="showNext">
            <el-button class="footer-button right-floated" @click="next">{{nextLabel}} <i class="el-icon-d-arrow-right"></i></el-button>
          </span>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import config from '../../appsettings.js'
import time from '../../api/contest/time'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: "contestfooter",
  data() {
    return {

    }
  },
  watch: {
    currentState: {
      handler: function(val, oldVal) {
          if(val) {
            const order = val.order;
            if(order === 2)
              this.startTimer();
            else if(order === 4)
              this.stopTimer();
          }
      }
    }
  },
  methods: {
    tryExit() {
      this.$confirm('Вы действительно хотите завершить тест?', 'Предупреждение', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Отмена',
        type: 'warning'
      }).then(() => {
        //this.finishTest();
        this.forceFinish();
      }).catch(() => {

      });
    },
    goNextState(skip) {
      this.processLoad(true);
      let self = this;
      let prefix = config.API_PREFIX;
      this.$gf.getOptions().then(options => {
        options.params = {
        };
        let payload = this.createPayload(skip);
        let order = payload.stage;
        self.$http.post(`${prefix}testing/next`, payload, options).then(response => {
          if(order && order === 3 && !skip)
            this.passQuestion();
          let data = response.data;
          this.processData(data);
          this.processLoad(false);
        }).catch(data => {
          if(data && data.status) {
            let status = data.status;
            if(status === 401 || status === 403 || status === 404 || status === 500)
              this.exit();
          }
          this.processLoad(false);
          self.$gf.checkError(data);
        });
      }).catch(err => {
        this.processLoad(false);
        this.$gf.catchOptions();
        this.forceFinish();
      });
    },
    createPayload(skip) {
      if(this.currentState && this.currentState.order) {
        let order = this.currentState.order;
        switch(order) {
          case 1:
            return { userScenarioUid : this.scenarioUid, stage : order };
          case 2:
            return { userScenarioUid : this.scenarioUid, testUid : this.testUid, stage : order };
          case 3:
            if(skip)
              return { userScenarioUid : this.scenarioUid, testUid : this.testUid, questionUid : this.questionUid, timeElapsed : this.elapsedTime, stage : order };
            else
              return { userScenarioUid : this.scenarioUid, testUid : this.testUid, questionUid : this.questionUid, timeElapsed : this.elapsedTime, answer : { answers : this.checkedAnswers, text :  this.inputedAnswer }, stage : order };
          case 4:
              this.stopTimer();
              return { userScenarioUid : this.scenarioUid, stage : order };
          case 5:
              //TODO:
              return { userScenarioUid : this.scenarioUid, stage : order };
          case 6:
              return { userScenarioUid : this.scenarioUid, timeElapsed : this.elapsedTime, stage : order };
        }
      }
      return null;
    },
    processData(data) {
      this.resetAnswer();
      if(data) {
        this.nextState(data.stage);
        if(this.currentState && this.currentState.order) {
          let order = this.currentState.order;
          switch(order) {
            case 2:
              this.initializeTest(data.data);
              break;
            case 3:
              Event.$emit('newQuestionAsked');
              this.initializeQuestion(data.data);
              break;
            case 4:
              this.passTest();
              this.initializeQuestion(null);
              break;
            case 5:
              this.initializeReport(data.data);
              break;
            case 6:
              this.initializeExit(data.data);
              break;
          }
        }
      }
      this.toState(this.currentState);
    },
    next() {
      let checkAnswer = this.currentState && this.currentState.order && this.currentState.order === 3;

      if(checkAnswer && !this.inputedAnswer && (!this.checkedAnswers || !this.checkedAnswers.length))
        this.skip(true);
      else
        this.goNextState(false);
    },
    toState(state) {
      if(state) {
          const path = state.path;
          if(path)
            this.$router.push(path);
          else
            this.finish();
      } else
        this.finish();
    },
    skip(show) {
      if(show) {
        this.$confirm('На вопрос не был дан ответ. Пропустить?', 'Предупреждение', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Отмена',
          type: 'warning'
        }).then(() => {
          this.goNextState(true);
        }).catch(() => {

        });
      } else {
        this.goNextState(true);
      }
    },
    forceFinish() {
      this.processLoad(true);
      let self = this;
      let prefix = config.API_PREFIX;
      this.$gf.getOptions().then(options => {
        options.params = {
        };
        let order = null;
          if(this.currentState && this.currentState.order)
            order = this.currentState.order;
        self.$http.post(`${prefix}testing/abort`, { userScenarioUid : this.scenarioUid, timeElapsed : this.elapsedTime, stage : order }, options).then(response => {
          this.finish();
          this.processLoad(false);
        }).catch(data => {
          this.processLoad(false);
          self.$gf.checkError(data);
        });
      }).catch(err => {
        this.processLoad(false);
        this.$gf.catchOptions();
        this.finish();
      });
    },
    finish() {
      this.stopTimer();
      this.exit();
      this.$router.push(config.WELCOME_URL);
    },
    finishTest() {
      this.stopTimer();
      ///TODO finish test
      this.setStateByOrder(4);
      this.toState(this.currentState);
    },
    startTimer() {
      if(this.testTime)
        this.setTimer(window.setInterval(this.tick, 1000));
    },
    stopTimer() {
      if(this.timer) {
        window.clearInterval(this.timer);
        this.setTimer(null);
      }
    },
    tick() {
      const elapsed = this.elapsedTime / 60;
      if(elapsed >= this.testTime) {
        //this.finishTest();
        this.forceFinish();
        this.$alert('Время истекло. Тест был автоматически завершен ', 'Предпурждение', {
          confirmButtonText: 'OK'
        });
      } else {
        this.timerTick();
      }
    },
    ...mapActions([
      'exit',
      'nextState',
      'setTimer',
      'setStateByOrder',
      'timerTick',
      'getEstimatedTime',
      'resetAnswer',
      'initializeTest',
      'initializeQuestion',
      'passTest',
      'passQuestion',
      'processLoad',
      'initializeReport',
      'initializeExit'
    ])
  },
  computed: {
    estimatedTime: function () {
      if(this.testTime)
        return time.formatMinutes(this.testTime  * 60 - this.elapsedTime);
      return time.formatMinutes(null);
    },
    timePercenatge: function () {
      if(this.testTime) {
        return Math.floor((this.elapsedTime / (this.testTime * 60)) * 100);
      }
      return 0;
    },
    testPercentage: function() {
      if(this.scenarioTestsCount && this.scenarioTestsPassedCount)
        return Math.floor((this.scenarioTestsPassedCount / this.scenarioTestsCount) * 100);
      return 0;
    },
    questionPercentage: function() {
      if(this.testQuestionsCount && this.testQuestionsPassedCount)
        return Math.floor((this.testQuestionsPassedCount / this.testQuestionsCount) * 100);
      return 0;
    },
    ...mapGetters([
      'currentState',
      'showNext',
      'showExit',
      'showSkip',
      'showProgress',
      'nextLabel',
      'testTime',
      'elapsedTime',
      'timer',
      'checkedAnswers',
      'inputedAnswer',
      'scenarioUid',
      'testUid',
      'scenarioTestsCount',
      'scenarioTestsPassedCount',
      'testQuestionsCount',
      'testQuestionsPassedCount',
      'questionUid'
    ])
  },
  created: function() {
    if(this.timer)
      this.startTimer();
  }
}
</script>

<style scoped>
  .middle-aligned {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .grid-content {
    min-height: 40px;
  }
  .grid-content-small {
    min-height: 18px;
  }
  .footer-button {
    width: 110px;
    height: 36.5px;
  }
  .footer-text {
    color: #eef1f6;
    font-size: 14px;
    margin-top: -2px;
  }
  .centered {
    text-align: center;
  }
  .right-floated {
    float: right;
  }
</style>

<style>
  .exit-button > * {
    margin-left: -12px;
  }
  .footer-button {
    line-height: 0.5 !important;
  }
  .skip-button > * {
    margin-left: -5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/contest/footer.vue